interface NamedActor {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
}

/**
 * Nombre visible de un actor: nombre + apellido, o el email si no los tiene.
 * `fallback` cubre a quien tampoco tiene email (o llega en null).
 */
export const actorName = (
  actor: NamedActor | null | undefined,
  fallback = '',
): string => {
  const full = `${actor?.first_name ?? ''} ${actor?.last_name ?? ''}`.trim();
  return full || actor?.email || fallback;
};
